import { votingIds } from "@artists/challenges-testkit"
import { Card, CardMedia } from "@artists/uikit"
import { Button } from "@mui/material"
import { memo, type ReactNode } from "react"
import { useTranslation } from "react-i18next"

import type { EntryWithVote } from "../../../api/hooks/vote"
import { ActionCard, useActionStatuses } from "../action-card"
import { CardActions } from "./card-actions"

interface Props {
	entry: EntryWithVote
	isSelected?: boolean
	actionButton: ReactNode
	onPdpClick?: () => void
}

export const VoteCommonCard = memo(
	({ entry, isSelected, actionButton, onPdpClick }: Props) => {
		const { t } = useTranslation("common")
		const action = useActionStatuses(entry)

		if (action) {
			return (
				<ActionCard
					{...action}
					actions={
						actionButton && (
							<Button variant='outlined' disabled fullWidth>
								{t("vote.vote")}
							</Button>
						)
					}
				/>
			)
		}

		return (
			<Card
				data-testid={votingIds.entry(entry.id)}
				sx={({ transitions: { create, duration } }) => ({
					"&::before": {
						inset: 0,
						border: 3,
						zIndex: 1,
						content: "''",
						borderRadius: "5px",
						position: "absolute",
						pointerEvents: "none",
						willChange: "border-color",
						borderColor: isSelected ? "black" : "transparent",
						transition: create("border-color", {
							duration: duration.short,
						}),
					},
				})}
			>
				<CardMedia image={entry.entryImage} imageModal />

				<CardActions
					entry={entry}
					isChecked={!!isSelected}
					actionButton={actionButton}
					onPdpClick={onPdpClick}
				/>
			</Card>
		)
	},
)
